<section class="icip-pricing" aria-label="Pricing">
  <div class="icip-pricing__starfield" #starfield aria-hidden="true">
    <span
      class="icip-pricing__star"
      *ngFor="let s of stars; trackBy: trackByIndex"
      [style.top]="s.top"
      [style.left]="s.left"
      [style.width.px]="s.sizePx"
      [style.height.px]="s.sizePx"
      [style.opacity]="s.opacity"
      [style.animationDelay]="s.delayS + 's'"
      [style.animationDuration]="s.durationS + 's'"
      [style.--dx]="s.driftXPx + 'px'"
      [style.--dy]="s.driftYPx + 'px'"
    ></span>
  </div>

  <canvas class="icip-pricing__confetti" #confettiCanvas aria-hidden="true"></canvas>

  <ng-container *ngIf="germanyEligibilityModalOpen">
    <div class="icip-germany-modal__backdrop" @backdrop (click)="closeGermanyEligibilityModal()"></div>

    <div class="icip-germany-modal__wrap" @modal>
      <div class="icip-germany-modal" (click)="$event.stopPropagation()">
        <div class="icip-germany-modal__flag" aria-hidden="true">🇩🇪</div>
        <h3 class="icip-germany-modal__title">Available in Germany</h3>
        <p class="icip-germany-modal__sub">
          Our self-service plans are currently available in Germany. We're expanding to more
          countries soon — if you're based elsewhere, our team would love to help.
        </p>
        <div class="icip-germany-modal__actions">
          <button type="button" class="icip-germany-modal__cta-btn" (click)="talkToSalesFromGermanyModal()">
            Talk to Sales
          </button>
          <button type="button" class="icip-germany-modal__dismiss-btn" (click)="confirmGermanyEligibility()">
            I'm in Germany — continue
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="icip-pricing__container">
    <div class="icip-pricing__header">
      <h2 id="pricing" class="icip-pricing__title">Flexible plans that scale with you</h2>
      <p class="icip-pricing__subtitle">
        Choose the perfect INFORM plan. Save up to 25% when you pay upfront.
      </p>
    </div>

    <div class="icip-pricing__billing-wrap">
      <div class="icip-pricing__billing" #billingEl aria-label="Billing selector">
        <div class="icip-pricing__burst-layer" #burstLayer aria-hidden="true"></div>
        <div class="icip-pricing__billing-pill" [style.width]="pillStyle.width" [style.transform]="pillStyle.transform"></div>

        <button
          #billingBtn
          *ngFor="let opt of billingOptions"
          type="button"
          class="icip-pricing__billing-btn"
          [class.is-active]="billingTerm === opt.id"
          [attr.data-term]="opt.id"
          (click)="selectBilling(opt.id, $event)"
        >
          <span class="icip-pricing__billing-label">{{ opt.label }}</span>
          <span
            *ngIf="opt.discount"
            class="icip-pricing__billing-discount"
            [class.is-active]="billingTerm === opt.id"
          >
            {{ opt.discount }}
          </span>
        </button>
      </div>
    </div>

    <div class="icip-pricing__eligibility-inline" *ngIf="showGermanyInlineNotice">
      <span class="icip-pricing__eligibility-inline-flag" aria-hidden="true">🇩🇪</span>
      <div class="icip-pricing__eligibility-inline-copy">
        <p class="icip-pricing__eligibility-inline-title">Currently available in Germany</p>
        <p class="icip-pricing__eligibility-inline-sub">
          More countries launching soon. Outside Germany? We'd love to connect.
        </p>
      </div>
      <button type="button" class="icip-pricing__eligibility-inline-cta" (click)="openSalesModal()">
        Talk to Sales
        <span class="icip-pricing__eligibility-inline-arrow" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14" />
            <path d="M13 6l6 6-6 6" />
          </svg>
        </span>
      </button>
    </div>

    <div class="icip-pricing__grid icip-reveal" appInView>
      <article
        class="icip-pricing-card"
        *ngFor="let plan of plans; trackBy: trackByPlanName"
        [class.is-popular]="plan.isPopular"
      >
        <div class="icip-pricing-card__popular" *ngIf="plan.isPopular" aria-label="Most popular">
          <span class="icip-pricing-card__popular-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
            </svg>
          </span>
          Most Popular
        </div>

        <div class="icip-pricing-card__body">
          <h3 class="icip-pricing-card__name">{{ plan.name }}</h3>
          <p class="icip-pricing-card__desc">{{ plan.description }}</p>

          <div class="icip-pricing-card__price">
            <span class="icip-pricing-card__price-value">
              {{ formatPlanCurrency(plan, animatedPrices[plan.name] ?? getPlanPrice(plan, billingTerm)) }}
            </span>
            <span class="icip-pricing-card__price-unit">/ mo</span>
          </div>

          <p class="icip-pricing-card__billing" aria-live="polite">
            {{ (!plan.monthlyOnly && billingTerm !== 'monthly') ? getBillingLabel() : '' }}
          </p>

          <div class="icip-pricing-card__features">
            <ul class="icip-pricing-card__list" role="list">
              <li class="icip-pricing-card__item" *ngFor="let f of plan.features; trackBy: trackByString">
                <span class="icip-pricing-card__item-icon" aria-hidden="true" [ngSwitch]="f === 'Custom Display Name'">
                  <svg *ngSwitchCase="true" width="18" height="18" viewBox="0 0 24 24" fill="#071D49" fill-opacity="0.10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg *ngSwitchDefault width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </span>
                <span class="icip-pricing-card__item-text" [class.is-highlight]="f === 'Custom Display Name'">
                  {{ f }}
                </span>
              </li>
            </ul>
          </div>

          <div class="icip-pricing-card__cta">
            <button
              type="button"
              class="icip-pricing-card__cta-btn"
              [class.is-primary]="plan.isPopular"
              [class.is-outline]="!plan.isPopular"
              (click)="onPlanCtaClick(plan)"
            >
              <span class="icip-pricing-card__cta-shimmer" aria-hidden="true"></span>
              <span class="icip-pricing-card__cta-label">{{ plan.buttonText }}</span>
            </button>
          </div>
        </div>
      </article>
    </div>

    <div class="icip-pricing-enterprise icip-reveal" appInView>
      <div class="icip-pricing-enterprise__card">
        <div class="icip-pricing-enterprise__inner">
          <div class="icip-pricing-enterprise__left">
            <div class="icip-pricing-enterprise__top">
              <div class="icip-pricing-enterprise__pill">
                <span class="icip-pricing-enterprise__pill-icon" aria-hidden="true">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 21V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v13" />
                    <path d="M9 21V12h6v9" />
                    <path d="M9 6V3h6v3" />
                  </svg>
                </span>
                Enterprise
              </div>
              <span class="icip-pricing-enterprise__dot">·</span>
              <span class="icip-pricing-enterprise__meta">Custom pricing</span>
            </div>

            <h3 class="icip-pricing-enterprise__title">Built for high-volume calling</h3>

            <ul class="icip-pricing-enterprise__list" role="list">
              <li
                class="icip-pricing-enterprise__item"
                *ngFor="let f of enterpriseFeatures; trackBy: trackByString"
              >
                <span class="icip-pricing-enterprise__item-icon" aria-hidden="true" [ngSwitch]="f === 'Custom Display Name'">
                  <svg *ngSwitchCase="true" width="16" height="16" viewBox="0 0 24 24" fill="#071D49" fill-opacity="0.10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg *ngSwitchDefault width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </span>
                <span class="icip-pricing-enterprise__item-text" [class.is-highlight]="f === 'Custom Display Name'">
                  {{ f }}
                </span>
              </li>
            </ul>
          </div>

          <div class="icip-pricing-enterprise__right">
            <div class="icip-pricing-enterprise__cta-head">
              <div class="icip-pricing-enterprise__cta-title">Ready to scale?</div>
              <div class="icip-pricing-enterprise__cta-sub">Our European team will reach out within 1 business day.</div>
            </div>

            <button type="button" class="icip-pricing-enterprise__cta-btn" (click)="openSalesModal()">
              Talk to Sales
              <span class="icip-pricing-enterprise__cta-arrow" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12h14" />
                  <path d="M13 6l6 6-6 6" />
                </svg>
              </span>
            </button>

            <div class="icip-pricing-enterprise__cta-foot">
              <span class="icip-pricing-enterprise__cta-phone" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 16.92V19a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 11.19 17.93a19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 3 4.18 2 2 0 0 1 5 2h2.09a2 2 0 0 1 2 1.72c.12.86.33 1.7.62 2.51a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.57-1.57a2 2 0 0 1 2.11-.45c.81.29 1.65.5 2.51.62A2 2 0 0 1 22 16.92z" />
                </svg>
              </span>
              No commitment required
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="salesModalOpen">
    <div class="icip-pricing-modal__backdrop" @backdrop (click)="closeSalesModal()"></div>

    <div class="icip-pricing-modal__wrap" @modal>
      <div class="icip-pricing-modal" (click)="$event.stopPropagation()">
        <button type="button" class="icip-pricing-modal__close" (click)="closeSalesModal()" aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18" />
            <path d="M6 6 18 18" />
          </svg>
        </button>

        <ng-container *ngIf="!submitted; else successState">
          <form class="icip-pricing-modal__form" #salesForm="ngForm" (submit)="submitSalesRequest($event, salesForm)">
            <div class="icip-pricing-modal__head">
              <div class="icip-pricing-modal__badge">
                <span class="icip-pricing-modal__badge-icon" aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 21V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v13" />
                    <path d="M9 21V12h6v9" />
                    <path d="M9 6V3h6v3" />
                  </svg>
                </span>
                Enterprise
              </div>
              <h3 class="icip-pricing-modal__title">Talk to Sales</h3>
              <p class="icip-pricing-modal__sub">
                Tell us a bit about your needs and our team will get back to you within 1 business day.
              </p>
            </div>

            <div class="icip-pricing-modal__grid">
              <label class="icip-pricing-field">
                <span class="icip-pricing-field__label">Work Email<span class="icip-pricing-field__req">*</span></span>
                <input class="icip-pricing-field__input" [class.icip-pricing-field__input--invalid]="emailModel.invalid && (emailModel.touched || formSubmitAttempted)"
                  type="email" name="email" required email maxlength="255" #emailModel="ngModel" [(ngModel)]="form.email" placeholder="you@company.com" />
                <span class="icip-pricing-field__error" *ngIf="emailModel.invalid && (emailModel.touched || formSubmitAttempted)">
                  {{ emailModel.errors?.['required'] ? 'Work email is required.' : 'Enter a valid email address.' }}
                </span>
              </label>

              <div class="icip-pricing-modal__row">
                <label class="icip-pricing-field">
                  <span class="icip-pricing-field__label">First Name<span class="icip-pricing-field__req">*</span></span>
                  <input class="icip-pricing-field__input" [class.icip-pricing-field__input--invalid]="firstNameModel.invalid && (firstNameModel.touched || formSubmitAttempted)"
                    type="text" name="firstName" required maxlength="100" #firstNameModel="ngModel" [(ngModel)]="form.firstName" placeholder="Jane" />
                  <span class="icip-pricing-field__error" *ngIf="firstNameModel.invalid && (firstNameModel.touched || formSubmitAttempted)">First name is required.</span>
                </label>

                <label class="icip-pricing-field">
                  <span class="icip-pricing-field__label">Last Name<span class="icip-pricing-field__req">*</span></span>
                  <input class="icip-pricing-field__input" [class.icip-pricing-field__input--invalid]="lastNameModel.invalid && (lastNameModel.touched || formSubmitAttempted)"
                    type="text" name="lastName" required maxlength="100" #lastNameModel="ngModel" [(ngModel)]="form.lastName" placeholder="Smith" />
                  <span class="icip-pricing-field__error" *ngIf="lastNameModel.invalid && (lastNameModel.touched || formSubmitAttempted)">Last name is required.</span>
                </label>
              </div>

              <label class="icip-pricing-field">
                <span class="icip-pricing-field__label">Company Name<span class="icip-pricing-field__req">*</span></span>
                <input class="icip-pricing-field__input" [class.icip-pricing-field__input--invalid]="companyModel.invalid && (companyModel.touched || formSubmitAttempted)"
                  type="text" name="company" required maxlength="200" #companyModel="ngModel" [(ngModel)]="form.company" placeholder="Acme Corp" />
                <span class="icip-pricing-field__error" *ngIf="companyModel.invalid && (companyModel.touched || formSubmitAttempted)">Company name is required.</span>
              </label>

              <label class="icip-pricing-field">
                <span class="icip-pricing-field__label">Which scenario fits your needs?<span class="icip-pricing-field__req">*</span></span>
                <select class="icip-pricing-field__input" [class.icip-pricing-field__input--invalid]="scenarioModel.invalid && (scenarioModel.touched || formSubmitAttempted)"
                  name="scenario" required #scenarioModel="ngModel" [(ngModel)]="form.scenario">
                  <option value="" disabled>Select a scenario…</option>
                  <option *ngFor="let s of scenarios; trackBy: trackByString" [value]="s">{{ s }}</option>
                </select>
                <span class="icip-pricing-field__error" *ngIf="scenarioModel.invalid && (scenarioModel.touched || formSubmitAttempted)">Please select a scenario.</span>
              </label>

              <label class="icip-pricing-field">
                <span class="icip-pricing-field__label">Country<span class="icip-pricing-field__req">*</span></span>
                <select class="icip-pricing-field__input" [class.icip-pricing-field__input--invalid]="countryModel.invalid && (countryModel.touched || formSubmitAttempted)"
                  name="country" required #countryModel="ngModel" [(ngModel)]="form.countryId">
                  <option [ngValue]="null" disabled>Select your country…</option>
                  <option *ngFor="let c of countries" [ngValue]="c.id">{{ c.name }}</option>
                </select>
                <span class="icip-pricing-field__error" *ngIf="countryModel.invalid && (countryModel.touched || formSubmitAttempted)">Please select your country.</span>
              </label>

              <label class="icip-pricing-field">
                <span class="icip-pricing-field__label">Estimated Monthly Call Volume<span class="icip-pricing-field__req">*</span></span>
                <select class="icip-pricing-field__input" [class.icip-pricing-field__input--invalid]="callVolumeModel.invalid && (callVolumeModel.touched || formSubmitAttempted)"
                  name="callVolume" required #callVolumeModel="ngModel" [(ngModel)]="form.callVolume">
                  <option value="" disabled>Select a volume range…</option>
                  <option *ngFor="let v of callVolumes; trackBy: trackByString" [value]="v">{{ v }}</option>
                </select>
                <span class="icip-pricing-field__error" *ngIf="callVolumeModel.invalid && (callVolumeModel.touched || formSubmitAttempted)">Please select an estimated call volume.</span>
              </label>

              <label class="icip-pricing-field">
                <span class="icip-pricing-field__label">Phone Number<span class="icip-pricing-field__req">*</span></span>
                <div class="business-phone-group d-flex" #phoneCountryDropdown>
                  <div class="country-dropdown">
                    <div class="selected d-flex align-items-center justify-content-between" (click)="toggleCountryDropdown()" tabindex="0">
                      <ng-container *ngIf="selectedCountryCode; else countryCodePlaceholder">
                        <div class="d-flex align-items-center">
                          <img [src]="selectedCountryCode.flag" width="20" class="me-1" alt="" />
                          <span>{{ selectedCountryCode.telephoneCode }}</span>
                        </div>
                      </ng-container>
                      <ng-template #countryCodePlaceholder>
                        <div class="d-flex align-items-center">
                          <span class="placeholder-flag"></span>
                          <span class="text-muted">+1</span>
                        </div>
                      </ng-template>
                      <span class="chevron">▾</span>
                    </div>
                    <div class="country-dropdown-menu" *ngIf="isCountryDropdownOpen">
                      <div class="country-search px-2 pt-2 pb-1">
                        <input type="text" class="form-control form-control-sm"
                          [value]="countrySearchTerm"
                          (input)="onCountrySearch($any($event.target).value)"
                          placeholder="Search"
                          (click)="$event.stopPropagation()" />
                      </div>
                      <div class="country-list country-options">
                        <div class="dropdown-item d-flex align-items-center justify-content-between"
                          *ngFor="let country of filteredCountries"
                          (click)="selectCountryCode(country); $event.stopPropagation()">
                          <div class="d-flex align-items-center">
                            <img [src]="country.flag" width="20" class="me-3" alt="" />
                            <span class="country-name">{{ country.name }}</span>
                          </div>
                          <span class="country-code">{{ country.telephoneCode }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <input class="icip-pricing-field__input business-phone-input" [class.icip-pricing-field__input--invalid]="phoneModel.invalid && (phoneModel.touched || formSubmitAttempted)"
                    type="tel" name="phone" required maxlength="15" #phoneModel="ngModel" [(ngModel)]="form.phone" (input)="onPhoneInput($event)"
                    [placeholder]="(selectedCountryCode?.telephoneCode || '+1') + ' (555) 123-4567'" />
                </div>
                <span class="icip-pricing-field__error" *ngIf="phoneModel.invalid && (phoneModel.touched || formSubmitAttempted)">Phone number is required.</span>
              </label>

              <label class="icip-pricing-field">
                <span class="icip-pricing-field__label">How can we help you? <span class="icip-pricing-field__optional">(optional)</span></span>
                <textarea class="icip-pricing-field__input" name="message" [(ngModel)]="form.message" maxlength="500" rows="3" placeholder="Tell us about your current setup, goals, or any questions…"></textarea>
                <span class="icip-pricing-field__char-count" [class.icip-pricing-field__char-count--limit]="(form.message?.length || 0) >= 500">
                  {{ form.message?.length || 0 }}/500 characters ({{ 500 - (form.message?.length || 0) }} left)
                </span>
              </label>

              <div class="icip-pricing-field">
                <app-terms-checkbox
                  name="termsAccepted"
                  #termsModel="ngModel"
                  [(ngModel)]="form.termsAccepted"
                ></app-terms-checkbox>
                <span class="icip-pricing-field__error" *ngIf="termsModel.invalid && (termsModel.touched || formSubmitAttempted)">
                  You must accept the terms and conditions.
                </span>
              </div>

              <div class="icip-pricing-modal__submit">
                <p class="icip-pricing-modal__form-error" *ngIf="salesRequestError">{{ salesRequestError }}</p>
                <button type="submit" class="icip-pricing-modal__submit-btn" [disabled]="isSubmittingSalesRequest || salesForm.invalid">
                  <span class="icip-pricing-modal__submit-btn-shine" aria-hidden="true"></span>
                  <span class="icip-pricing-modal__submit-btn-label">{{ isSubmittingSalesRequest ? 'Submitting…' : 'Submit Request' }}</span>
                </button>
                <p class="icip-pricing-modal__fineprint">
                  By submitting, you agree that a member of our team will contact you. No spam, ever.
                </p>
              </div>
            </div>
          </form>
        </ng-container>

        <ng-template #successState>
          <div class="icip-pricing-modal__success">
            <div class="icip-pricing-modal__success-icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </div>
            <div class="icip-pricing-modal__success-title">Request sent</div>
            <div class="icip-pricing-modal__success-sub">Our European team will be in touch within 1 business day.</div>
            <button type="button" class="icip-pricing-modal__success-link" (click)="closeSalesModal()">
              Back to pricing
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
</section>
